export const SHOULD_LOCALISATION_SHOW_DELIVERY_MESSAGING = false;
export const BULKY_DELIVERY_DEFAULT_EXPERIENCE = 'Scheduled';
export const DEFAULT_CACHE_LIFETIME_SECONDS = 3600;

export const DEFAULT_TAB_LOCAL_STORAGE_KEY = 'localisation-default-tab';

export const CUSTOM_EVENT_LOCATION_MODAL_OPENED = 'location-modal-opened';
